import React from 'react'
import PageHero from '../components/PageHero'
import PageLayout from '../components/PageLayout'
const EducationPage: React.FC = () => {
    return (
        <PageLayout>
            <PageHero title="Education" image="./img/kids/yhds.jpeg" imageAlt="Young History Detectives participating in an educational program" />
            <section className="py-5" id="services">
                <div className="container my-5">
                    <div className="row">
                        <div className="col">
                            <div className="text-center">
                                <h3 className="section-subheading text-muted">
                                    Businesses and fellow foundations have given their time and support to help us make a difference in children&apos;s lives.
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col"></div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="text-center mt-5 yhd">
                                <h2>Young History Detectives</h2>
                                <p>
                                    YHD participants learn research skills, history, and oral storytelling. Oral Histories preserve community history uniquely.
                                    We explore storytelling through art, music, dance, gaming, creative writing, illustration, yoga, meditation, sound therapy,
                                    and photography.
                                </p>
                                <p>
                                    Each day blends calm and creativity—with daily yoga, mindfulness, and journaling to start us off right. Art, games, and fun
                                    are built into our routine, along with exciting trips to UNO’s Wellness Center for swimming or rock climbing. We’ll also
                                    explore Omaha through tours, visit the Durham History Museum and historic landmarks, connect with inspiring community
                                    leaders, and dive into the rich stories that bring our city to life!
                                </p>
                                <p className="lead">New program dates will be announced soon.</p>
                            </div>
                        </div>
                    </div>
                    <div className="text-center mt-5">
                        <h2>Pictures from our Events</h2>
                    </div>

                    <div className="container mt-5">
                        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3">
                            <div className="col">
                                <img src="./img/education/edimg1.jpeg" alt="Young History Detectives learning together" className="img-fluid" loading="lazy" />
                            </div>
                            <div className="col">
                                <img src="./img/education/edimg2.jpeg" alt="Students participating in a House education activity" className="img-fluid" loading="lazy" />
                            </div>
                            <div className="col">
                                <img src="./img/education/edimg3.jpeg" alt="Youth exploring history through a creative activity" className="img-fluid" loading="lazy" />
                            </div>
                            <div className="col">
                                <img src="./img/education/edimg4.jpeg" alt="Young History Detectives program participants" className="img-fluid" loading="lazy" />
                            </div>
                            <div className="col">
                                <img src="./img/education/edimg5.jpeg" alt="Students collaborating during an education program" className="img-fluid" loading="lazy" />
                            </div>
                            <div className="col">
                                <img src="./img/education/edimg6.jpg" alt="A community learning activity hosted by The House" className="img-fluid" loading="lazy" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </PageLayout>
    )
}

export default EducationPage
